import { render, staticRenderFns } from "./dependentAlteration.vue?vue&type=template&id=120cd7c2&scoped=true&style=background%3A%20var(--v-muted-base)&"
import script from "./dependentAlteration.vue?vue&type=script&lang=js&"
export * from "./dependentAlteration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120cd7c2",
  null
  
)

export default component.exports